import React from "react";

const createComponent = (Tag, defaultClasses) =>
  React.forwardRef(({ className = "", ...props }, ref) => (
    <Tag ref={ref} className={`${defaultClasses} ${className}`} {...props} />
  ));

const Card = createComponent(
  "div",
  "rounded-xl border bg-card text-card-foreground shadow"
);
const CardHeader = createComponent("div", "space-y-1.5 p-6");
const CardTitle = createComponent(
  "div",
  "font-semibold leading-none tracking-tight"
);
const CardDescription = createComponent("div", "text-sm text-muted-foreground");
const CardContent = createComponent("div", "p-6 pt-0");
const CardFooter = createComponent("div", "flex items-center p-6 pt-0");

Card.displayName = "Card";
CardHeader.displayName = "CardHeader";
CardTitle.displayName = "CardTitle";
CardDescription.displayName = "CardDescription";
CardContent.displayName = "CardContent";
CardFooter.displayName = "CardFooter";

export {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
};
